import {
  LOGIN_PROCEED_CLICKED,
  LOGINTYPE,
  LOGIN_SIGNUP_START,
} from './../../constants/auth';
import { setMobileNumberLocal, setAutofillFlag } from 'shared/helpers/auth';
import { pages } from 'shared/constants/urls';
import { pushData } from 'helpers/utils/dataLayer';
import { pushEvent } from '@nykaa/nes-data-layer';

export const ACTIONS = {
  SEND_OTP: '1',
  SIGN_IN: '2',
  GOOGLE_SIGN: '3',
};

export const TRACKING = {
  VIEW: 'auto_fill',
  SEND_OTP: 'send_otp_autoFill',
  PAGE: 'mweb:welcomeScreen',
  AUTO_FILL_CLOSE: 'autofillClose',
  SIGNUP_NUDGE_OPENED: 'signpNudgeOpened',
};

export const CURRENT_URL = 'CURRENT_URL';

export const loginPageName = () => {
  let loginPage = 'homePage';
  let cURL = null;
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      cURL = window.localStorage.getItem(CURRENT_URL);
      if (cURL?.includes('/p/')) {
        loginPage = 'productDetailPage';
      } else if (cURL?.includes('/reviews/')) {
        loginPage = 'productReviewPage';
      } else if (cURL?.includes('/widgetName/')) {
        loginPage = 'recoWidget';
      } else if (cURL?.includes('/c/')) {
        loginPage = 'categoryListingPage';
      } else if (cURL?.includes('/brand/')) {
        loginPage = 'brandListingPage';
      } else if (
        cURL?.includes('/searchWidget=') ||
        cURL?.includes('/search/')
      ) {
        loginPage = 'searchListingPage';
      } else if (cURL?.includes('/shoppingBag')) {
        loginPage = 'cartPage';
      } else if (cURL?.includes('/wishlist')) {
        loginPage = 'wishlistPage';
      } else if (cURL?.includes('/hlp')) {
        loginPage = 'hybridLP';
      } else if (cURL?.includes('/coupon-offers')) {
        loginPage = 'couponOffersPage';
      }
    }
    return loginPage || '';
  } catch (error) {
    return '';
  }
};

export const getEncodedURl = () =>
  encodeURIComponent(`${window.location.pathname}${window.location.search}`);

export const redirectToAuthVerify = (root?: string) => {
  const url = `${pages.AUTH_PAGE_VERIFY}&redirect=${getEncodedURl()}${
    root ? `&root=${root}` : ''
  }`;
  setTimeout(() => {
    window.location.href = url;
  }, 500);
};

export const redirectToAuth = (root?: string) => {
  const url = `${pages.AUTH_PAGE}&redirect=${getEncodedURl()}${
    root ? `&root=${root}` : ''
  }`;
  setTimeout(() => {
    window.location.href = url;
  }, 500);
};

export const handleAutoFillSubmit = (mobile: string) => {
  pushData({ event: TRACKING.SEND_OTP });
  pushEvent(LOGIN_PROCEED_CLICKED, {
    loginType: LOGINTYPE.PHONE,
    login_page: loginPageName(),
  });
  setMobileNumberLocal(mobile);
  setAutofillFlag(ACTIONS.SEND_OTP);
  redirectToAuthVerify();
};

export const handleLogin = () => {
  setAutofillFlag(ACTIONS.SIGN_IN);
  redirectToAuthVerify('auto_fill');
  pushEvent(LOGIN_SIGNUP_START, {
    loginType: LOGINTYPE.PHONE_EMAIL,
    login_page: loginPageName(),
  });
};
export const handleGLogin = () => {
  setAutofillFlag(ACTIONS.GOOGLE_SIGN);
  redirectToAuth();
  pushEvent(LOGIN_SIGNUP_START, {
    loginType: LOGINTYPE.GOOGLE,
    login_page: loginPageName(),
  });
};

export const trackView = (data: any) => {
  const { number, clickInteraction = '' } = data;
  const autoFill = {
    pageName: TRACKING.PAGE,
    event: TRACKING.VIEW,
    phfill: number ? 1 : 0,
  };
  pushData({
    autoFill,
    ...(clickInteraction && { clickInteraction }),
  });
};
